export const PAYMENT_METHOD_DIRECTION = {
  PAY: 'pay',
  RECEIVE: 'receive'
};
